/** @format */

import React from 'react';
import { Statistic } from 'antd';

export default function CustomStatistic(props) {
	return <Statistic {...props} />;
}
